export function mergeGuestData(originalGuests, targetGuests) {
  return targetGuests.map((targetGuest) => {
    const match = originalGuests.find(
      (original) =>
        original.title === targetGuest.title &&
        original.firstName === targetGuest.firstName &&
        original.lastName === targetGuest.lastName
    );
    const guest = match ? { ...match, ...targetGuest } : targetGuest;
    return guest;
  });
}
